import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CarsState } from '../../types';

import { getLocationSharingConstraints } from '../operations/getLocationSharingConstraints';

import { STATUS_LOADING } from 'common/constants';

export const setLocationSharingConstraints = (builder: ActionReducerMapBuilder<CarsState>) => builder
  .addCase(getLocationSharingConstraints.pending, (state) => {
    state.locationSharingConstraints.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getLocationSharingConstraints.fulfilled, (state, { payload }) => {
    state.locationSharingConstraints.loadingStatus = STATUS_LOADING.done;
    state.locationSharingConstraints.data = payload;
  })
  .addCase(getLocationSharingConstraints.rejected, (state) => {
    state.locationSharingConstraints.loadingStatus = STATUS_LOADING.error;
  });
